import { Section, stagger } from "./Section";

const P = "text-[15px] leading-[1.7] text-[#4A5568]";

export const Hero = () => (
  <Section id="hero" className="bg-white" testId="hero-section">
    <div className="grid gap-10 lg:grid-cols-[55fr_45fr] lg:gap-16">
      <div>
        <p className="als-eyebrow" data-testid="hero-kicker">Philippines · Energy &amp; Infrastructure</p>
        <div className="mt-6 border-l-2 border-[#1B3A6B] pl-6">
          <h1 className="text-[36px] sm:text-[48px] font-medium leading-[1.1] tracking-[-0.02em] text-[#1B3A6B]" data-testid="hero-heading">
            Local capability for energy and infrastructure projects in the Philippines
          </h1>
        </div>
      </div>
      <div className="flex flex-col justify-end gap-8">
        <p className={P} data-testid="hero-subline">
          Arka Likas Solutions (ALS) supports developers, owners, investors and project teams from early project
          development through construction, commissioning and operations.
        </p>
        <div>
          <a href="#contact" className="btn-cta-dark" data-testid="hero-cta-button">Discuss a Project</a>
        </div>
      </div>
    </div>
  </Section>
);

const ABOUT = [
  "ALS is an independent, Philippine-anchored energy and infrastructure solutions company based in Pasig City, Metro Manila.",
  "Incorporated in 2023, ALS combines local market capability with access to specialist engineering, technology, and advisory partners appropriate to each assignment. We are partner-neutral.",
  "ALS has 700+ MW of advisory and project support experience, with active assignments from 5-200\u00A0MW across solar PV, wind, and Battery Energy Storage Systems (BESS).",
];

export const About = () => (
  <Section id="about" className="about-bg text-white" style={{ backgroundImage: "url(/about-sun.jpg)" }} testId="about-section">
    <p className="about-tagline reveal-item" data-testid="about-tagline">Arka is Sun. Likas is Nature.</p>
    <div className="mt-12 grid gap-8 text-[15px] leading-[1.7] text-white/90 lg:grid-cols-3 lg:gap-12" data-testid="about-copy">
      {ABOUT.map((t, i) => (
        <p key={i} className="reveal-item" style={stagger(i + 1)} data-testid={`about-paragraph-${i + 1}`}>{t}</p>
      ))}
    </div>
  </Section>
);

const MARKET = [
  "Renewable energy accounted for approximately 25% of Philippine gross power generation at the end of 2025, against national targets of 35% by 2030 and 50% by 2040.",
  "The Department of Energy is advancing a Green Energy Auction pipeline of at least 25 GW of additional renewable capacity through 2035.",
  "As more projects move from development into construction and operation, disciplined project development, quality, grid integration and execution will matter increasingly.",
];

export const Market = () => (
  <Section id="market-context" className="bg-navy-dots" testId="market-context-section">
    <div className="grid gap-10 lg:grid-cols-[0.45fr_0.55fr] lg:gap-16">
      <h2 className="als-heading" data-testid="market-context-heading">The Philippines is moving into a new phase of project delivery</h2>
      <div className={`space-y-6 ${P}`} data-testid="market-context-copy">
        {MARKET.map((t, i) => (
          <p key={i} className="reveal-item" style={stagger(i)} data-testid={`market-paragraph-${i + 1}`}>{t}</p>
        ))}
      </div>
    </div>
  </Section>
);
